module.exports = __webpack_public_path__ + "img/logo_ACG.a41d87d8.png";